import { render, staticRenderFns } from "./SlideShowAdd.vue?vue&type=template&id=0cc7b06a&scoped=true&"
import script from "./SlideShowAdd.vue?vue&type=script&lang=js&"
export * from "./SlideShowAdd.vue?vue&type=script&lang=js&"
import style0 from "./SlideShowAdd.vue?vue&type=style&index=0&id=0cc7b06a&scoped=true&lang=css&"
import style1 from "./SlideShowAdd.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc7b06a",
  null
  
)

export default component.exports